export class ConditionConditionSetApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createConditionConditionSet(body) {
    return this.#http.post('/conditionConditionSet', body);
  }

  async deleteConditionConditionSet({ conditionConditionSetId }) {
    return this.#http.delete(`/conditionConditionSet/${conditionConditionSetId}`);
  }
}
